/* CLAYAN — floating WhatsApp positioning.
   Keeps clear of the privacy banner and of the B2B floating order summary. */
(() => {
  const init = () => {
    const wa = document.querySelector('[data-clayan-whatsapp]');
    if (!wa) return;

    const isVisible = (el) => {
      if (!el) return false;
      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
    };

    const setBottomOffset = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const base = mobile ? 18 : 24;
      let bottom = base;

      /* B2B: the fixed order-summary button owns the lower-right corner. */
      const summary = document.querySelector('.clayan-b2b-summary-fab');
      if (isVisible(summary)) {
        const rect = summary.getBoundingClientRect();
        const gap = mobile ? 12 : 14;
        bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top + gap));
      }

      /* Native privacy banner can be taller than both controls. */
      const banner = document.querySelector('.shopify-pc__banner__dialog') || document.querySelector('#shopify-pc__banner');
      if (isVisible(banner)) {
        const rect = banner.getBoundingClientRect();
        const touchesBottom = rect.bottom >= window.innerHeight - 24;
        if (touchesBottom) {
          bottom = Math.max(bottom, Math.ceil(window.innerHeight - rect.top + 14));
        }
      }

      const next = `${bottom}px`;
      if (wa.style.getPropertyValue('--clayan-wa-bottom') !== next) {
        wa.style.setProperty('--clayan-wa-bottom', next);
      }
    };

    setBottomOffset();
    window.addEventListener('resize', setBottomOffset, { passive: true });
    window.addEventListener('scroll', setBottomOffset, { passive: true });

    const observer = new MutationObserver(setBottomOffset);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open'] });

    document.addEventListener('click', (event) => {
      if (event.target.closest('#shopify-pc__banner, .shopify-pc__banner__dialog, .shopify-pc__prefs__dialog')) {
        window.setTimeout(setBottomOffset, 120);
        window.setTimeout(setBottomOffset, 400);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
